import React, { useState, useEffect } from 'react';

interface NumericInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  className?: string;
}

/**
 * Numeric input that allows free text editing (select all, delete, retype).
 * Uses type="text" with inputMode="numeric" to avoid browser number spinner issues.
 * Clamps to min/max on blur.
 */
export const NumericInput: React.FC<NumericInputProps> = ({
  value,
  onChange,
  min = 0,
  max,
  disabled = false,
  className = '',
}) => {
  const [local, setLocal] = useState(String(value));

  useEffect(() => { setLocal(String(value)); }, [value]);

  return (
    <input
      type="text"
      inputMode="numeric"
      value={local}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9]/g, '');
        setLocal(raw);
        if (raw !== '') {
          let num = parseInt(raw);
          if (max !== undefined) num = Math.min(max, num);
          onChange(Math.max(min, num));
        }
      }}
      onBlur={() => {
        let num = parseInt(local) || min;
        num = Math.max(min, num);
        if (max !== undefined) num = Math.min(max, num);
        setLocal(String(num));
        onChange(num);
      }}
      disabled={disabled}
      className={className}
    />
  );
};
